import React from "react";

export const Arrow = ({
  color = "black",
  width = 31,
  height = 27,
  x = 0,
  y = 0,
}) => {
  return (
    <svg
      width={width}
      height={height}
      x={x}
      y={y}
      viewBox="0 0 31 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.169111 13.3957C0.169111 14.0587 0.432505 14.6946 0.901346 15.1635C1.37019 15.6323 2.00607 15.8957 2.66911 15.8957H22.4691L15.9024 22.4624C15.4608 22.9363 15.2204 23.5631 15.2319 24.2108C15.2433 24.8584 15.5057 25.4764 15.9637 25.9344C16.4217 26.3925 17.0397 26.6549 17.6874 26.6663C18.335 26.6777 18.9619 26.4373 19.4358 25.9957L30.2691 15.1624C30.7373 14.6936 31.0002 14.0582 31.0002 13.3957C31.0002 12.7332 30.7373 12.0978 30.2691 11.629L19.4358 0.795694C19.2069 0.550072 18.9309 0.353064 18.6242 0.216425C18.3176 0.0797846 17.9865 0.00631169 17.6509 0.000389073C17.3152 -0.00553354 16.9817 0.0562149 16.6705 0.181952C16.3592 0.307688 16.0764 0.494837 15.839 0.732233C15.6016 0.969629 15.4144 1.25241 15.2887 1.5637C15.163 1.875 15.1012 2.20843 15.1071 2.5441C15.1131 2.87978 15.1865 3.21082 15.3232 3.51749C15.4598 3.82415 15.6568 4.10015 15.9024 4.32903L22.4691 10.8957H2.66911C1.28911 10.8957 0.169111 12.0157 0.169111 13.3957Z"
        fill={color}
      />
    </svg>
  );
};
